/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { onSelectAddOnCarouseHandler } from '../../../utils/products';
import { Card, Container, Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Summary from '../../Summary';
import { useResponsiveValue } from '@theme-ui/match-media';
import { RulesType, RulesName } from '../../../enums';
import { MotorplayPlanCarousel, PlanCard } from './components';

const AddOnsSelectionPage = ({
  selectedPlan,
  history,
  client,
  shoppingCart,
  addProduct,
  user,
  addOnsToShow,
  addOnList,
  setAddOnsToShow,
  deleteCouponCode,
  applyProductRules,
  couponApply,
  subscriptions,
}) => {
  const numberOfCards = useResponsiveValue([1, 2, 2]);
  const addOnProducts = addOnsToShow || addOnList;

  const handleContinueClick = () => {
    history.push('../methods' + history.location.search);
  };

  useEffect(() => {
    if (addOnsToShow.length === 0) {
      applyProductRules({ ruleType: RulesType.ADDITIONAL_PURCHASE, ruleName: RulesName.PLAN_ADDONS_OFFERING, productId: selectedPlan.productID });
      applyProductRules({ ruleType: RulesType.PURCHASE, ruleName: RulesName.PLAN_INCLUDE_ADDONS, productId: selectedPlan.productID });
    }
  }, [addOnsToShow]);

  useEffect(() => {
    if (shoppingCart.exchange?.currency && shoppingCart.exchange.currency !== user.currency) {
      // TODO: Revisar implementacion
    }
    if (couponApply.code) {
      deleteCouponCode();
    }
  }, [user.currency, couponApply]);

  if (!selectedPlan) {
    return <Redirect to={`/${client}/subscribe/subscriptions${history.location.search}`} />;
  }

  return (
    <Container className="MembershipSelectionPage">
      <div className="myaccount-title">
        <p className="h6 text-uppercase">
          <FormattedMessage
            id="MyAccount.title"
          />
        </p>
      </div>
      <Row>
        <Col className="tbx-carousel-addOns-container">
          <Card className="tbx-card-carousel" style={{ backgroundColor: '#000000bd' }}>
            <MotorplayPlanCarousel
              products={addOnProducts}
              numberOfCards={numberOfCards}
              renderCard={({ product, productId, isDescriptionExpanded, onDescriptionExpandChange }) => (
                <PlanCard
                  key={productId}
                  plan={product}
                  selected={product.isSelected}
                  isBlocked={product.isBlocked}
                  isDescriptionExpanded={isDescriptionExpanded}
                  onDescriptionExpandChange={onDescriptionExpandChange}
                  onSelect={() => {
                    onSelectAddOnCarouseHandler(
                      product,
                      addOnProducts,
                      setAddOnsToShow,
                      addProduct
                    );
                  }}
                />
              )}
            />
          </Card>
        </Col>
        <Col className="summary-content left">
          <div className="summary-content-body">
            <Summary
              subscriptions={subscriptions}
              selectedProducts={shoppingCart?.productsToBuy}
              handleContinueButton={handleContinueClick}
              user={user}
            />
          </div>
        </Col>
      </Row>
    </Container>)
};

export default AddOnsSelectionPage;